import CreatePartyModal from '@features/games/modals/create-party-modal/create-party-modal';
export default CreatePartyModal;
